import { queryReferencesAt } from '../index.js';
import type { CodeNavOpContext } from './code-nav-op-context.js';
import type { CodeNavHttpBody } from './types.js';

export async function runReferencesOp(ctx: CodeNavOpContext): Promise<CodeNavHttpBody> {
  const references = await queryReferencesAt(ctx.sessionParentPath, ctx.reqPath, ctx.line, ctx.column);
  return { indexReady: true, references };
}
